import PopupProductionTimeGroup from './PopupProductionTimeGroup'
import { createVNode, createApp, reactive } from "vue";

export const showPopupProductionTimeGroup = (options: {
  isBlank: boolean;
}): Promise<any> => {
  return new Promise((resolve, reject) => {

    const state = reactive({
      visible: true
    })

    const container = document.createElement('div')
    options = options || {};
    const confirmOpts = {
      ...options,
      open: true,
      callback: (data: any) => {
        resolve(data)
        if (vm) vm.unmount();
      },
    };

    const vm = createApp({
      render: () => createVNode(PopupProductionTimeGroup, confirmOpts, state),
    });

    document.body.appendChild(container)
    vm.mount(container as any);
  });
}
